import {useQuery} from "@tanstack/react-query"
import {API} from "config"
import Moment from "moment";

const useBestReferral = (term, period) => useQuery({
    queryKey: ['best-referral', term, period], queryFn: async () => {
        const params = new URLSearchParams({
            // page,
            ...(term && { term }),
            ...(period?.[0] && { start: Moment(period[0]).format('YYYY-MM-DD HH:mm:ss') }),
            ...(period?.[1] && { end: Moment(period[1]).format('YYYY-MM-DD HH:mm:ss') }),
        });

        const callback = await API.get(`reports/best-referral?${params}`);
        return callback?.data
    },
    staleTime: 1000 * 60 * 60,
    gcTime: 1000 * 60 * 60 * 24
})

export default useBestReferral